import styled from 'styled-components';
import {getToken} from '@tickchak/react-share/app';
import {dFlex, justifyBetween, alignCenter, flexWrap} from '../../../../globalVariables/GlobalFlex';

export const headerBar = styled.div`
    ${dFlex};
    ${justifyBetween};
    ${alignCenter};
    ${flexWrap};
    width: 100%;
    padding: var(--space-lg);
    background: ${getToken('color.bg.surface.default')};
    gap: var(--space-sm);
`;
